/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './body-cell.component.ngfactory';
import * as i2 from '@swimlane/ngx-datatable/release/components/body/body-cell.component';
import * as i3 from '@angular/common';
import * as i4 from '@swimlane/ngx-datatable/release/components/body/body-row.component';
import * as i5 from '@swimlane/ngx-datatable/release/services/scrollbar-helper.service';
const styles_DataTableBodyRowComponent:any[] = ([] as any[]);
export const RenderType_DataTableBodyRowComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableBodyRowComponent,data:{}});
function View_DataTableBodyRowComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'datatable-body-cell',
      [['class','datatable-body-cell'],['tabindex','-1']],[[8,'className',0],[4,'width',
          'px'],[4,'height',(null as any)]],[[(null as any),'activate'],[(null as any),
          'focus'],[(null as any),'blur'],[(null as any),'click'],[(null as any),'dblclick'],
          [(null as any),'keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('focus' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onFocus()) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('click' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,1).onClick($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('dblclick' === en)) {
          const pd_3:any = ((<any>i0.ɵnov(_v,1).onDblClick($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('keydown' === en)) {
          const pd_4:any = ((<any>i0.ɵnov(_v,1).onKeyDown($event)) !== false);
          ad = (pd_4 && ad);
        }
        if (('activate' === en)) {
          const pd_5:any = ((<any>_co.onActivate($event,_v.context.index)) !== false);
          ad = (pd_5 && ad);
        }
        return ad;
      },i1.View_DataTableBodyCellComponent_0,i1.RenderType_DataTableBodyCellComponent)),
      i0.ɵdid(180224,(null as any),0,i2.DataTableBodyCellComponent,[i0.ElementRef],
          {row:[0,'row'],column:[1,'column'],rowHeight:[2,'rowHeight'],isSelected:[3,
              'isSelected']},{activate:'activate'}),(_l()(),i0.ɵted((null as any),
          ['\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = _co.row;
    const currVal_4:any = _v.context.$implicit;
    const currVal_5:any = _co.rowHeight;
    const currVal_6:any = _co.isSelected;
    _ck(_v,1,0,currVal_3,currVal_4,currVal_5,currVal_6);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).columnCssClasses;
    const currVal_1:any = i0.ɵnov(_v,1).width;
    const currVal_2:any = i0.ɵnov(_v,1).height;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_DataTableBodyRowComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(278528,(null as any),0,i3.NgStyle,[i0.KeyValueDiffers,i0.ElementRef,
          i0.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n      '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_DataTableBodyRowComponent_2)),i0.ɵdid(802816,(null as any),0,i3.NgForOf,
          [i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf'],
              ngForTrackBy:[1,'ngForTrackBy']},(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.stylesByGroup(_v.context.$implicit.type);
    _ck(_v,1,0,currVal_1);
    const currVal_2:any = _v.context.$implicit.columns;
    const currVal_3:any = _co.columnTrackingFn;
    _ck(_v,4,0,currVal_2,currVal_3);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵinlineInterpolate(1,'datatable-row-',_v.context.$implicit.type,
        ' datatable-row-group');
    _ck(_v,0,0,currVal_0);
  });
}
export function View_DataTableBodyRowComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DataTableBodyRowComponent_1)),
      i0.ɵdid(802816,(null as any),0,i3.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf'],ngForTrackBy:[1,'ngForTrackBy']},
          (null as any)),(_l()(),i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i4.DataTableBodyRowComponent = _v.component;
    const currVal_0:any = _co.columnsByPin;
    const currVal_1:any = _co.trackByGroups;
    _ck(_v,2,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_DataTableBodyRowComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'datatable-body-row',
      ([] as any[]),[[8,'className',0],[4,'height','px'],[4,'width','px']],[[(null as any),
          'keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onKeyDown($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_DataTableBodyRowComponent_0,RenderType_DataTableBodyRowComponent)),i0.ɵdid(49152,
      (null as any),0,i4.DataTableBodyRowComponent,[i5.ScrollbarHelper,i0.ElementRef],
      (null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).cssClass;
    const currVal_1:any = i0.ɵnov(_v,1).rowHeight;
    const currVal_2:any = i0.ɵnov(_v,1).columnsTotalWidths;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export const DataTableBodyRowComponentNgFactory:i0.ComponentFactory<i4.DataTableBodyRowComponent> = i0.ɵccf('datatable-body-row',
    i4.DataTableBodyRowComponent,View_DataTableBodyRowComponent_Host_0,{columns:'columns',
        innerWidth:'innerWidth',rowClass:'rowClass',row:'row',offsetX:'offsetX',isSelected:'isSelected',
        rowHeight:'rowHeight'},{activate:'activate'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3cuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3cuY29tcG9uZW50LmQudHMiLCJuZzovLy9zcmMvdWkvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L2JvZHktcm93LmNvbXBvbmVudC5kLnRzLkRhdGFUYWJsZUJvZHlSb3dDb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3cuY29tcG9uZW50LmQudHMuRGF0YVRhYmxlQm9keVJvd0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXZcbiAgICAgICpuZ0Zvcj1cImxldCBjb2xHcm91cCBvZiBjb2x1bW5zQnlQaW47IGxldCBpID0gaW5kZXg7IHRyYWNrQnk6IHRyYWNrQnlHcm91cHNcIlxuICAgICAgY2xhc3M9XCJkYXRhdGFibGUtcm93LXt7Y29sR3JvdXAudHlwZX19IGRhdGF0YWJsZS1yb3ctZ3JvdXBcIlxuICAgICAgW25nU3R5bGVdPVwic3R5bGVzQnlHcm91cChjb2xHcm91cC50eXBlKVwiPlxuICAgICAgPGRhdGF0YWJsZS1ib2R5LWNlbGxcbiAgICAgICAgKm5nRm9yPVwibGV0IGNvbHVtbiBvZiBjb2xHcm91cC5jb2x1bW5zOyBsZXQgaWkgPSBpbmRleDsgdHJhY2tCeTogY29sdW1uVHJhY2tpbmdGblwiXG4gICAgICAgIHRhYmluZGV4PVwiLTFcIlxuICAgICAgICBbcm93XT1cInJvd1wiXG4gICAgICAgIFtpc1NlbGVjdGVkXT1cImlzU2VsZWN0ZWRcIlxuICAgICAgICBbY29sdW1uXT1cImNvbHVtblwiXG4gICAgICAgIFtyb3dIZWlnaHRdPVwicm93SGVpZ2h0XCJcbiAgICAgICAgKGFjdGl2YXRlKT1cIm9uQWN0aXZhdGUoJGV2ZW50LCBpaSlcIj5cbiAgICAgIDwvZGF0YXRhYmxlLWJvZHktY2VsbD5cbiAgICA8L2Rpdj5cbiAgIiwiPGRhdGF0YWJsZS1ib2R5LXJvdz48L2RhdGF0YWJsZS1ib2R5LXJvdz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDS007TUFBQTtVQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBT0U7VUFBQTtVQUFBO1FBQUE7UUFQRjtNQUFBO2FBQUE7VUFBQTtjQUFBLHNDQU9zQztVQUFBOztJQUpwQztJQUVBO0lBQ0E7SUFGQTtJQUpGLFdBR0UsVUFFQSxVQUNBLFVBRkEsU0FKRjs7SUFBQTtJQUFBO0lBQUE7SUFBQSxXQUFBLDZCQUFBOzs7O29CQUpGO01BQUE7YUFBQTtxQkFBQSx5Q0FHMkM7VUFBQSxlQUN6QztVQUFBLDBDQUFBO1VBQUE7Y0FBQSxnREFRc0I7VUFBQTs7SUFUdEI7SUFIRixXQUdFLFNBSEY7SUFLSTtJQUFBO0lBREYsV0FDRSxtQkFERjs7SUFGQTtRQUFBO0lBRkYsV0FFRSxTQUZGOzs7O29CQURKLDJDQUNJO01BQUE7YUFBQTs0QkFBQTtVQUFBLGVBYU07O0lBWko7SUFBQTtJQURGLFdBQ0UsbUJBREY7Ozs7b0JDREo7TUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsaUZBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQSw2QkFBQTs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./aot_output/~/@swimlane/ngx-datatable/release/components/body/body-row.component.ngfactory.ts